<template>
<div class="flex-fill fill flex column ofy">
<tabs v-model="tab" :tabs="tabs" :keyByTab="true" :alwaysVisible="true" @OnTabChanged="TabChanged($event)"
:tabCount="tabCount" tabCountOnSelectedOnly>

    <div slot="Mesas" class="pa-body">
        <div class="secondary-text mt10 ta-center" v-if="tables === null || !Util.Arr(tables).length">No hay mesas</div>
        <div class="mb20" v-for="section in tablesSorted" :key="section.section">
            <div class="flex align-center mb20">
                <div class="f18 flex-fill flex align-center">{{section.section}} <span class="counter">{{section.tables.length}}</span></div>
                <i class="options icon-dots-vertical" @click="Options([
                    {text: 'Nueva Mesa', function: () => {ClickNewTable(section.section)}, icon: 'plus'}
                ])"></i>
            </div>
            <div class="section mb10"
            v-for="(table, key) in section.tables" :key="key">
                <div class="fill flex align-center">

                    <avatar class="mr10"
                    defaultImageIcon="3152"
                    :imageIcon="section.section"
                    :color="TableColor(table)">
                    </avatar>
                    
                    <div class="flex column flex-fill">
                        <div class="bold">{{table.name}} <span class="tag ml5" v-if="TableLayout(table)">Mapa</span></div>
                        <div class="secondary-text" v-if="table.seats">{{table.seats}} sillas</div>
                        <div class="secondary-text" v-if="table.reserved">Mesa reservada para el {{Util.Date(table.reservation_data.date, 'LLLL')}}</div>
                        <div class="secondary-text" v-if="table.id_transaction">Mesa activa</div>
                        <div class="secondary-text" v-if="!table.available">Mesa deshabilitada</div>
                        <div class="secondary-text" v-if="table.parent_table">Mesa unida a {{table.parent_table}}</div>
                    </div>
                    <i class="options icon-dots-vertical" @click="Options([
                        {text: 'Eliminar', class: 'error-color', confirm: `¿Eliminar ${table.name}?`, function: () => {DeleteTable(table)}, if: !table.id_transaction && !table.parent_table, icon: 'trash'},
                        {text: 'Editar Mesa', class: '', function: () => {ClickEditTable(table)}, if: !table.id_transaction && !table.parent_table, icon: 'edit'},
                        {text: 'Habilitar Mesa', confirm: `¿Habilitar ${table.name}?`, function: () => {TableAvailability(table, true)}, if: !table.available && !table.parent_table, icon: 'square-check'},
                        {text: 'Deshabilitar Mesa', confirm: `¿Deshabilitar ${table.name}?`, function: () => {TableAvailability(table, false)}, if: !!table.available && !table.id_transaction && !table.parent_table, icon: 'forbidden'},
                        {text: 'Liberar Mesa', confirm: `¿Liberar ${table.name}? Si hay un pedido activo seguirá pendiente`, function: () => {FreeTable(table)}, icon: 'clean'},
                    ])"></i>
                </div>
            </div>
        </div>
        <!--
        <div class="section" v-else>
            <div class="input-style"
            v-for="(table, key) in tables" :key="key">
                <div class="fill flex align-center">
                    <i class="icon icon-cross mr10 c3" title="Mesa deshabilitada" v-if="!table.available"></i>
                    <i class="icon icon-receipt mr10 c3" title="Mesa activa" v-if="table.id_transaction"></i>
                    <i class="icon icon-datetime mr10 c3" title="Mesa reservada" v-if="table.reserved"></i>
                    <div class="flex-fill bold">{{table.name}} <span class="secondary-text" v-if="table.section">({{table.section}})</span></div>
                    <i class="options icon-dots-vertical" @click="Options([
                        {text: 'Eliminar', class: 'error-color', confirm: `¿Eliminar ${table.name}?`, function: () => {DeleteTable(table)}, if: !table.id_transaction},
                        {text: 'Habilitar Mesa', confirm: `¿Habilitar ${table.name}?`, function: () => {TableAvailability(table, true)}, if: !table.available},
                        {text: 'Deshabilitar Mesa', confirm: `¿Deshabilitar ${table.name}?`, function: () => {TableAvailability(table, false)}, if: table.available},
                    ])"></i>
                </div>
            </div>
        </div>
        -->
    </div>

    <local-staff-view ref="staffView" slot="Cuentas" @OnAccountsChanged="accountsCount = $event.length"></local-staff-view>
    <iap-settings v-if="tabs.includes('Pedidos Online')" slot="Pedidos Online" ref="iapSettings"></iap-settings>
    <local-profile-settings slot="General" ref="profile" class="pa-body" @OnSettingsSaved="OnSettingsSaved()"></local-profile-settings>
    <local-sii-settings v-if="tabs.includes('SII')" ref="sii" slot="SII"></local-sii-settings>
    <virtual-menu-settings v-if="tabs.includes('Menú Virtual')" ref="virtualMenu" slot="Menú Virtual"></virtual-menu-settings>
    <totem-settings v-if="tabs.includes('Totem')" ref="totem" slot="Totem"></totem-settings>

    <div class="opt r">
        <input-select v-if="tab == 'Pedidos Online' && Auth.role.indexOf('admin') !== -1 && Local.type == 'LOCAL' && itemBrands.length" class="mr10" inputClass="secondary"
        :items="itemBrands" v-model="selectBrand" :triggerFirstValueChanged="false" @OnValueChanged="$refs.iapSettings.SelectBrand(selectBrand)" :icon="mobile ? 'shop' : ''">
        </input-select>
        <button class="primary purple" @click="SaveOnlineOrders()" v-show="tab=='Pedidos Online'">Guardar</button>
        <button class="primary purple" @click="$refs.modules.Save()" v-show="tab=='Módulos'">Guardar</button>
        <button class="primary purple" @click="$refs.profile.Save()" v-show="tab=='General'">Guardar</button>
        <button class="primary purple" @click="$refs.virtualMenu.Save()" v-show="tab=='Menú Virtual'">Guardar</button>
        <button class="primary purple" @click="$refs.totem.Save()" v-show="tab=='Totem'">Guardar</button>
        <button class="primary purple" @click="SaveCategories()" v-show="tab=='Categorías'">Guardar</button>
        <i class="options icon-dots-vertical ml5" v-show="tab == 'General' && Auth.role == 'admin' && Local.type == 'LOCAL'" @click="Options([
            {text: 'Nueva Marca', if: tab == 'General' && Auth.role == 'admin' && Local.type == 'LOCAL', function: () => {$refs.profile.OpenModalNewBrand()}, icon: 'plus'}
        ])"></i>
        <i class="options icon-dots-vertical ml5" v-show="tab=='Mesas'" @click="Options([
            {text: 'Editar Mapa', if: !!(tables && Util.Arr(tables).length), function: () => {OpenFloorPlanEditor()}, icon: 'edit'},
            {text: 'Nueva Mesa', if: tab == 'Mesas', function: () => {ClickNewTable()}, icon: 'plus'},
        ])"></i>
        <i class="options icon-dots-vertical" v-if="Auth.role == 'admin'" v-show="tab=='SII'" @click="Options([
            {text: 'Reenviar Boletas', class: 'csupport', icon: 'lifebuoy', function: () => {$refs.sii.OpenResendBoletas()}}
        ])"></i>

    </div>

    <modal v-model="modalTable" :dir="['right', 'center']" :modalClass="['fill', 'sm']" :title="`${modalTable && modalTable.edit ? 'Editar':'Nueva'} Mesa`">
        <div class="section" v-if="modalTable">
            <input-field class="mb15"
            v-model="modalTable.name"
            label="Nombre"
            placeholder="(Ej: Mesa 1)">
            </input-field>
            <input-select
            v-model="modalTable.section"
            label="Sección"
            :items="tableSections"
            :canType="true">
            </input-select>
            <input-field class="mt15"
            v-model="modalTable.seats"
            type="int+"
            label="Sillas">
            </input-field>
        </div>
        
        <button slot="actions" class="primary purple" v-if="modalTable" @click="modalTable.edit ? EditTable() : SaveTable()">Guardar</button>
        
    </modal>

    <modal :value="floorPlanOpen" @input="CloseFloorPlanEditor" dir="right" modalClass="fill fullscreen floor-plan-modal" title="Mapa de mesas" hideActions>
        <button slot="options" class="primary purple mr5" @click="SaveFloorPlan" :disabled="!modalFloorPlan.floorPlanDirty">Guardar</button>
        <div class="floor-plan-editor flex column" v-if="floorPlanOpen">
            <div class="tabs floor-section-tabs" v-if="floorPlanSectionTabs.length">
                <div
                v-for="tab in floorPlanSectionTabs"
                :key="tab.key"
                class="pointer tab unselectable"
                :class="{'tab-selected': modalFloorPlan.floorPlanSection === tab.value}"
                @click="modalFloorPlan.floorPlanSection = tab.value">
                    {{ tab.label }}
                </div>
            </div>
            <div class="floor-plan-map-slot">
                <floor-map
                :key="'fp-' + floorPlanSectionKey"
                ref="floorMap"
                mode="edit"
                :tables="floorPlanTables"
                :elements="floorPlanElements"
                :view-width="floorPlanView.w"
                :view-height="floorPlanView.h"
                :ref-session="floorPlanRef"
                @change="OnFloorPlanChange"
                @elements-change="OnFloorPlanPatch({ elements: $event || [] })"
                @size-change="OnFloorPlanPatch"
                @ref-change="OnFloorPlanRef">
                </floor-map>
            </div>
        </div>
    </modal>
    <modal
    :dir="['right', 'center']" :modalClass="['fill', 'sm']"
    v-model="modalConfirmSaveBrands"
    :closeable="true"
    title="Guardar Ajustes"
    >
        <div class="section">¿Guardar la misma configuración en todas las marcas?</div>
        <button slot="actions" class="primary purple" v-if="modalConfirmSaveBrands" @click="$refs.iapSettings.Save(true);modalConfirmSaveBrands=false">Guardar en todas</button>
        <button slot="actions" class="primary purple" v-if="modalConfirmSaveBrands" @click="$refs.iapSettings.Save(false);modalConfirmSaveBrands=false">Guardar sólo este local</button>
    </modal>
</tabs>

</div>
</template>

<script>
import TotemSettings from './TotemSettings.vue';
export default {
    components: {TotemSettings},
    data() {
        return {
            tab: null,
            tables: null,
            modalTable: null,
            editTable : false,
            accountsCount: 0,
            selectBrand: null,
            brands: [],
            modalConfirmSaveBrands : false,
            modalFloorPlan: {},
        }
    },
    mounted() {

    },
    methods: {
        // Layout colocado de una mesa (overlay del editor o lo guardado).
        TableLayout(table) {
            var layouts = this.modalFloorPlan.floorPlanLayouts;
            var layout = (layouts && Object.prototype.hasOwnProperty.call(layouts, table.id))
                ? layouts[table.id]
                : (table.layout || null);
            return (layout && layout.x != null) ? layout : null;
        },
        // Abrir el editor y cargar el plano del local.
        OpenFloorPlanEditor() {
            this.CloseFloorPlanEditor();
            this.modalFloorPlan = {
                floorPlanSection: null,
                floorPlan: {},
                floorPlanLayouts: null,
                floorPlanDirty: false,
                floorPlanRefs: {},
            };
            this.Loading();
            var pickSection = () => {
                if(!this.floorPlanOpen) return;
                var tabs = this.floorPlanSectionTabs;
                if(!tabs.length) this.modalFloorPlan.floorPlanSection = '__undefined__';
                else if(!tabs.some(t => t.value === this.modalFloorPlan.floorPlanSection)) this.modalFloorPlan.floorPlanSection = tabs[0].value;
            };
            axios.get(`/floor/plan/${this.Local.id}`).then(res => {
                this.Response(res);
                if(!this.floorPlanOpen) return;
                var data = res.data;
                this.modalFloorPlan.floorPlan = (data && data.plan !== undefined)
                    ? ((data.plan && typeof data.plan === 'object' && !Array.isArray(data.plan)) ? data.plan : {})
                    : ((data && typeof data === 'object') ? data : {});
                pickSection();
            }).catch(err => {
                this.Response(err);
                if(!this.floorPlanOpen) return;
                this.modalFloorPlan.floorPlan = {};
                pickSection();
            });
        },
        // Cachear mesas movidas/quitadas hasta Guardar mapa.
        OnFloorPlanChange(payload) {
            var draft = this.modalFloorPlan;
            if(!draft.floorPlan) return;
            var next = Object.assign({}, draft.floorPlanLayouts || {});
            (payload || []).forEach(p => { next[p.id] = p.layout; });
            draft.floorPlanLayouts = next;
            draft.floorPlanDirty = true;
        },
        // Aplicar cambios del canvas sobre la sección activa (elementos o tamaño).
        OnFloorPlanPatch(patch) {
            var draft = this.modalFloorPlan;
            if(!draft.floorPlan) return;
            var prev = draft.floorPlan[this.floorPlanSectionKey] || {};
            this.$set(draft.floorPlan, this.floorPlanSectionKey, Object.assign({}, prev, patch));
            draft.floorPlanDirty = true;
        },
        // Guardar la imagen de referencia de la sección mientras el modal está abierto.
        OnFloorPlanRef(session) {
            var draft = this.modalFloorPlan;
            if(!draft.floorPlanRefs) return;
            var key = this.floorPlanSectionKey;
            var prev = draft.floorPlanRefs[key];
            if(!session) {
                if(prev && prev.url) URL.revokeObjectURL(prev.url);
                if(prev) this.$delete(draft.floorPlanRefs, key);
                return;
            }
            if(prev && prev.url && prev.url !== session.url) URL.revokeObjectURL(prev.url);
            this.$set(draft.floorPlanRefs, key, session);
        },
        // Cerrar el editor: suelta imágenes y deja el objeto vacío.
        CloseFloorPlanEditor() {
            var refs = this.modalFloorPlan.floorPlanRefs || {};
            Object.keys(refs).forEach(key => {
                if(refs[key] && refs[key].url) URL.revokeObjectURL(refs[key].url);
            });
            this.modalFloorPlan = {};
        },
        // Persistir el mapa de la sección actual.
        SaveFloorPlan() {
            var draft = this.modalFloorPlan;
            if(!draft.floorPlan) return;
            var tables = Object.keys(draft.floorPlanLayouts || {}).map(id => ({
                id: Number(id),
                layout: draft.floorPlanLayouts[id],
            }));
            var section = draft.floorPlan[this.floorPlanSectionKey] || {};
            this.Loading();
            Promise.all([
                axios.put(`/tables/${this.Local.id}/layout`, {tables}),
                axios.put(`/floor/plan/${this.Local.id}`, {
                    section: this.floorPlanSectionKey,
                    elements: section.elements || [],
                    w: section.w || 160,
                    h: section.h || 100,
                }),
            ]).then(([tablesRes, planRes]) => {
                this.Response(tablesRes);
                this.tables = tablesRes.data;
                if(draft !== this.modalFloorPlan) return;
                var data = planRes.data;
                draft.floorPlan = (data && data.plan !== undefined)
                    ? ((data.plan && typeof data.plan === 'object' && !Array.isArray(data.plan)) ? data.plan : {})
                    : ((data && typeof data === 'object') ? data : {});
                draft.floorPlanLayouts = null;
                draft.floorPlanDirty = false;
                if(this.$refs.floorMap) this.$refs.floorMap.FloorMarkClean();
                this.Info('Mapa guardado');
            }).catch(err => {
                this.Response(err);
            });
        },

        TabChanged(tab)
        {
            if(tab == 'Cuentas')
            {
                this.$refs.staffView.Init();
            }
            if(tab == 'Pedidos Online')
            {
                this.$refs.iapSettings.Init(true);
                if(this.Auth.role.indexOf('admin') !== -1) this.GetBrands();
            }
            if(tab == 'Menú Virtual')
            {
                this.$refs.virtualMenu.Init();
            }
            if(tab == 'SII')
            {
                this.$refs.sii.Init();
            }
            if(tab == 'Módulos')
            {
                this.$refs.modules.Init();   
            }
            if(tab == 'Mesas' &&  this.tables === null)
            {
                this.Loading();
                axios.get(`/tables/${this.Local.id}`).then(res => {
                    this.Response(res);
                    this.tables = res.data;
                }).catch(err => {
                    this.Response(err);
                });
            }
            if(tab == 'Totem')
            {
                this.$refs.totem.Init();
            }
        },
        ClickNewTable(section){
            this.modalTable = {name: '', available: true, id_transaction: null, edit : false, section: (section && section !== 'Sin definir' ? section : null), seats: 4}
        },
        ClickEditTable(table){
            this.modalTable = {id: table.id, name: table.name, section: table.section, available: true, id_transaction: null, edit : true, seats: table.seats != null ? table.seats : 0 }
        },
        SaveTable()
        {
            if(!this.modalTable.name) return this.Info('Nombre inválido'); 
            this.Loading();
            axios.put(`/tables/${this.Local.id}`, this.modalTable).then(res => {
                this.Response(res);
                this.tables = res.data;
                this.modalTable = null,
                this.editTable = false;
            }).catch(err => {
                this.Response(err);
            });
        },
        EditTable()
        {
            if(!this.modalTable.name) return this.Info('Nombre inválido'); 
            this.Loading();
            axios.put(`/tables/${this.Local.id}/edit`, this.modalTable).then(res => {
                this.Response(res);
                this.tables = res.data;
                this.modalTable = null,
                this.editTable = false;
            }).catch(err => {
                this.Response(err);
            });
        },
        DeleteTable(table) 
        {
            this.Loading();
            axios.patch(`/tables/${this.Local.id}/delete`, {table: table.name}).then(res => {
                this.Response(res);
                this.tables = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        TableAvailability(table, is_available) 
        {
            this.Loading();
            axios.patch(`/tables/${this.Local.id}/availability`, {table: table.name, is_available: is_available}).then(res => {
                this.Response(res);
                this.tables = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        FreeTable(table) 
        {
            this.Loading();
            axios.patch(`/tables/${this.Local.id}/free`, {table: table.name}).then(res => {
                this.Info('Mesa liberada');
                this.tables = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        TableColor(table)
        {
            if(table.reserved) return this.Util.baseColors.yellow;
            if(table.id_transaction) return this.Util.baseColors.green;
            if(!table.available) return this.Util.baseColors.red;
            if(table.parent_table) return this.Util.baseColors.green;
            return null;
        },
        OnSettingsSaved(){
            if(this.tabs.includes('Pedidos Online')) 
            {
                this.$refs.iapSettings.settings = null;
                this.$refs.iapSettings.location = null;
            }
        },
        GetBrands() {
            this.Loading();
            axios.get(`/local/${this.Local.id}/brands`).then(res => {
                this.Response(res);
                this.brands = res.data.map(brand => {return {text: brand.name, value: brand.id}});
            }).catch(err => {
                this.Response(err);
            });
        },
        SaveOnlineOrders() {
            if(this.brands.length && this.selectBrand == this.Local.id) this.modalConfirmSaveBrands = true; 
            else this.$refs.iapSettings.Save();
        }
    },
    beforeDestroy() {
        this.CloseFloorPlanEditor();
    },
    computed: 
    {
        floorPlanOpen() {
            return !!(this.modalFloorPlan && this.modalFloorPlan.floorPlan);
        },
        floorPlanSectionKey() {
            return this.modalFloorPlan.floorPlanSection || '__undefined__';
        },
        floorPlanRef() {
            var refs = this.modalFloorPlan.floorPlanRefs;
            return (refs && refs[this.floorPlanSectionKey]) || null;
        },
        floorPlanSectionTabs() {
            if(!this.tables) return [];
            var sections = {};
            var hasUndefined = false;
            Object.values(this.tables).forEach(t => {
                if(t.section) {
                    if(!sections[t.section]) sections[t.section] = { key: t.section, label: t.section, value: t.section };
                } else {
                    hasUndefined = true;
                }
            });
            var tabs = this.Util.NaturalSort(Object.values(sections), 'label');
            if(hasUndefined) tabs.push({ key: '__undefined__', label: 'Sin definir', value: '__undefined__' });
            return tabs;
        },
        floorPlanTables() {
            if(!this.tables || !this.floorPlanOpen || this.modalFloorPlan.floorPlanSection == null) return [];
            var list = Object.values(this.tables);
            if(this.modalFloorPlan.floorPlanSection === '__undefined__') list = list.filter(t => !t.section);
            else list = list.filter(t => t.section === this.modalFloorPlan.floorPlanSection);
            return list.map(t => {
                var layout = this.TableLayout(t);
                return Object.assign({}, t, {
                    layout: layout,
                    status: t.available ? 'AVAILABLE' : 'UNAVAILABLE',
                });
            });
        },
        floorPlanElements() {
            var plan = this.modalFloorPlan.floorPlan;
            var section = plan && plan[this.floorPlanSectionKey];
            return (section && section.elements) ? section.elements : [];
        },
        floorPlanView() {
            var plan = this.modalFloorPlan.floorPlan;
            var section = plan && plan[this.floorPlanSectionKey];
            return {
                w: (section && section.w) || 160,
                h: (section && section.h) || 100,
            };
        },
        tabs() {

            var ret = ['General'];
            if(this.Auth.role == 'local_admin' && this.Auth.restrictions_admin){
                if(this.Auth.restrictions_admin.settings_accounts_enabled) ret.push('Cuentas');
                if(this.Auth.restrictions_admin.settings_tables_enabled && this.Local.type == 'LOCAL' && this.Local.modules.module_tables) ret.push('Mesas');
                if(this.Auth.restrictions_admin.settings_online_orders_enabled && (this.Local.modules.module_store || this.Local.modules.module_store_plus)) ret.push('Pedidos Online');
                if(this.Auth.restrictions_admin.settings_menu_virtual_enabled && this.Local.modules.module_virtual_menu) ret.push('Menú Virtual');
                if(this.Auth.restrictions_admin.settings_totem_enabled && this.Local.modules.module_totem) ret.push('Totem');
                if(this.Auth.restrictions_admin.settings_sii_enabled && (this.Local.modules.module_sii_boleta || this.Local.modules.module_sii_factura)) ret.push('SII');
            }else{
                ret.push('Cuentas');
                if(this.Local.type == 'LOCAL' && this.Local.modules.module_tables) ret.push('Mesas');
                if(this.Local.modules.module_store || this.Local.modules.module_store_plus) ret.push('Pedidos Online');
                if(this.Local.modules.module_virtual_menu) ret.push('Menú Virtual');
                if(this.Local.modules.module_totem) ret.push('Totem');
                if(this.Local.modules.module_sii_boleta || this.Local.modules.module_sii_factura) ret.push('SII');
            }
            
            //if(this.Auth.role == 'admin' || this.Auth.role == 'sub_admin') ret.push('Categorías');
            //if(this.Auth.role == 'admin' || this.Auth.role == 'sub_admin') ret.push('Módulos');
            return ret;
        },
        tablesSorted() {
            var sections = {};
            var undefinedSection = {
                section: 'Sin definir',
                tables: []
            };

            for(var key in this.tables)
            {
                var table = this.tables[key];
                if(table.section)
                {
                    if(!sections[table.section]) sections[table.section] = {section: table.section, tables: []};
                    sections[table.section].tables.push(table);
                }
                else
                {
                    undefinedSection.tables.push(table);
                }
            }

            var ret = this.Util.NaturalSort(Object.values(sections), 'section');
            if(undefinedSection.tables.length) ret.push(undefinedSection);

            ret.forEach(section => {
                section.tables = this.Util.NaturalSort(section.tables, 'name');
            });

            return ret;
        },
        tableSections() {
            var ret = [{text: 'Sin definir', value: null}];
            if(!this.tables) return ret;

            var categories = {};

            for(var key in this.tables)
            {
                var section = this.tables[key].section;
                if(section && !categories[section])
                {
                    ret.push({text: section, value: section});
                    categories[section] = true;
                }
            }
            return ret;
        },
        tabCount() {
            return {
                Cuentas: this.accountsCount,
                Mesas: this.tables ? Object.values(this.tables).length : 0
            }
        },
        itemBrands() {
            if(this.$refs.iapSettings && this.brands.length){
                return [{text: this.Local.name, value: this.Local.id}, ...this.brands];
            }
            return [];
        }
    }
}
</script>

<style lang="scss">
.modal.floor-plan-modal .header .primary {
    padding: 6px 12px;
    font-size: 13px;
}
.modal.floor-plan-modal .body {
    overflow: hidden;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
.floor-plan-editor {
    padding: 0;
    flex: 1;
    min-height: 0;
    height: 100%;
}
.floor-plan-editor .floor-section-tabs {
    flex-shrink: 0;
    margin-bottom: 0;
    // padding: 8px 12px 0;
}
.floor-plan-map-slot {
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}
</style>